import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ProductType, ProductTypeDetails } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeService extends TmsWebBaseEditService<ProductType, ProductTypeDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductType', $localize`Product Type`);
  }

  getProcessType(): Observable<ProductType> {
    return this.httpService.get<ProductType>(`${this.apiUrl}/GetProcessType`);
  }
}
